import { capitalize } from "lodash";

export const quickKeyColors = {
  modifier: {
    text: "#fff",
    background: "#DFB93C",
    icon: "#fff",
  },
  action: {
    text: "#94B5FB",
    background: "#94B5FB",
    icon: "#94B5FB",
  },
  navy: {
    text: "#fff",
    background: "#203D4E",
    icon: "#fff",
  },
  lilac: {
    text: "#000",
    background: "#c7b6de",
    icon: "#000",
  },
  lightBlue: {
    text: "#000",
    background: "#739db9",
    icon: "#000",
  },
  lightGreen: {
    text: "#7ed5a0",
    background: "#2F6246",
    icon: "#7ed5a0",
  },
  gold: {
    text: "#000",
    background: "#bda16d",
    icon: "#000",
  },
  orange: {
    text: "#000",
    background: "#f49342",
    icon: "#000",
  },
  white: {
    text: "#000",
    background: "#fff",
    icon: "#000",
  },
} as const;

const quickKeyColorsPrefix = "quickKey" as const;

function common<S extends string, T extends Record<any, any>>(
  prefix: S,
  vals: T
) {
  const initialEntry = Object.entries(vals)[0];

  const obj = Object.entries(vals).reduce((quickKeyAcc, quickKeyEntry) => {
    const [suffix, value] = quickKeyEntry;
    return {
      ...quickKeyAcc,
      ...buildQuickKeyColors(prefix, suffix, value),
    };
  }, buildQuickKeyColors(prefix, initialEntry[0], initialEntry[1]));

  return obj;
}

function buildQuickKeyColors<S extends string, T extends string, U>(
  prefix: S,
  suffix: T,
  value: U
) {
  const key = `${quickKeyColorsPrefix}${capitalize(prefix)}${capitalize(
    suffix
  )}` as const;
  return { [key]: value };
}

export const flattenedQuickKeyColors = Object.entries(quickKeyColors).reduce(
  (acc, entry) => {
    const [prefix, quickKeyVals] = entry;

    const test = common(prefix, quickKeyVals);

    return { ...acc, ...test };
  },
  common(
    Object.entries(quickKeyColors)[0][0],
    Object.entries(quickKeyColors)[0][1]
  )
);
